<template>
  <div id="app">
    <meta content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0;" name="viewport" />
    <keep-alive>
      <!-- 需要缓存的视图组件 -->
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <!--v-if="$route.meta.keepAlive"  -->
    <!-- 不需要缓存、的视图组件 -->
    <!-- v-if="!$route.meta.keepAlive" -->
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>
<script>
import AlertFZ from "./common/js/AlertFZ";
import Util from "./common/js/util";
import axios from "axios";
export default {
  name: "App",
  data() {
    return {
      code: "",
      openid: "",
    };
  },
  methods: {
    getOption() {
      let params = `user/checkCode?code=${this.code}`;
      axios({
        headers: {
          "Content-Type": "application/json",
        },
        method: "get",
        url: Util.userUrl + params,
      }).then(function (res) {
        console.log(res);
        this.openid = res.data.result.openId;
        console.log(this.openid);
        localStorage.setItem("openId", this.openid);
        console.log(localStorage.getItem("openId"));
      });
    },
  },
  created() {
    // const local = 
    const local=window.location.href
    let bb = local.split("&");
    let ee=bb[1].split("=")
    let cc=ee[1].split("#/")
    console.log(cc);
    localStorage.setItem("OPENID666", cc[0]);
    let _this = this;
    var ua = navigator.userAgent.toLowerCase();
    var isWinxin = ua.indexOf("micromessenger") != -1;
    if (isWinxin) {
      let array = [];
      var name, value;
      var str = location.href; //取得整个地址栏
    } else {
      document.onkeydown = function (e) {
        //对整个页面文档监听
        var keyNum = window.event ? e.keyCode : e.which; //获取被按下的键值
        if (keyNum === 37) {
        }
      };
      document.addEventListener("plusready", function () {
        var webview = plus.webview.currentWebview();
        plus.key.addEventListener("backbutton", function () {
          webview.canBack(function (e) {
            let _webVIew = localStorage.getItem("webView");
            if (_webVIew === "false") {
              _this.$router.go(-1);
            } else {
              //webview.close(); //hide,quit
              //plus.runtime.quit();
              //首页返回键处理
              //处理逻辑：1秒内，连续两次按返回键，则退出应用；
              var first = null;
              plus.key.addEventListener(
                "backbutton",
                function () {
                  //首次按键，提示‘再按一次退出应用’
                  if (!first) {
                    first = new Date().getTime();
                    _this.$router.go(-1);
                    AlertFZ.AlertMsg("再按一次退出应用");
                    setTimeout(function () {
                      first = null;
                    }, 1000);
                  } else {
                    if (new Date().getTime() - first < 1500) {
                      plus.runtime.quit();
                    }
                  }
                },
                false
              );
            }
          });
        });
      });
    }
  },
};
</script>
<style>
@import url("./common/font/font.css");
html {
  font-size: 2.9vw;
}
#app {
  /* font-family: "PingFangLight"; */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  font-weight: 500;
  font-size: 1.1rem;
  /* background-color: #f9f9f9; */
  /* -webkit-overflow-scrolling: touch; */
}
input {
  background: transparent;
  border: none;
  outline: medium;
}
body {
  display: block;
  margin: 0;
  background-color: #f2f2f2;
}
.xuanzhongBG {
  background: #fff;
}
.borderBlue {
  border: 1px solid #87ceeb;
}
.borderRightBlue {
  border-right: 1px solid #87ceeb;
}
.colorBlue {
  color: #87ceeb;
}
.head_box {
  width: 100%;
  height: 3.5rem;
  line-height: 3.5rem;
  text-align: center;
  position: fixed;
  z-index: 5;
}
/* 
.tabar_one{
    width: 25%;
    height: 3.5rem;
    line-height: 3.5rem;
    float: left;
    color:#fff;
}
.tabar_two{
    width: 50%;
    height: 2.5rem;
    line-height: 2.5rem;
    float: right;
    text-align:center;
    font-size: 1.4rem;
    color:#fff;
}
.tabar_three{
    width: 25%;
    height: 3.5rem;
    line-height: 3.5rem;
    float: left;
    color:#fff;
} */
</style>



// WEBPACK FOOTER //
// src/App.vue